import { CURRICULUM } from "../../data/curriculum";

export default function HomeScreen({ xp, onSelectGrade }) {
  return (
    <div style={{ position: "relative", zIndex: 1, padding: "40px 20px", maxWidth: "900px", margin: "0 auto", textAlign: "center" }}>
      <div className="float" style={{ marginBottom: "8px" }}>
        <div style={{ fontSize: "80px", marginBottom: "0px" }}>🧮</div>
      </div>
      <h1 style={{
        fontFamily: "'Fredoka One', cursive",
        fontSize: "clamp(40px, 8vw, 72px)",
        color: "white",
        margin: "0 0 8px",
        textShadow: "0 0 40px rgba(100,150,255,0.5)",
        letterSpacing: "2px",
      }}>
        MathQuest
      </h1>
      <p style={{
        color: "#a0b4ff",
        fontSize: "clamp(16px, 3vw, 22px)",
        marginBottom: "12px",
        fontWeight: 600,
      }}>
        Your AI-Powered Math Adventure 🚀
      </p>
      <p style={{ color: "#7a8fd4", fontSize: "15px", marginBottom: "48px" }}>
        Grades 3–12 • Adaptive Practice • Real-Time AI Help
      </p>

      {xp > 0 && (
        <div className="pop-in" style={{
          background: "rgba(255,255,255,0.08)",
          borderRadius: "16px",
          padding: "16px 24px",
          marginBottom: "32px",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255,255,255,0.1)",
          display: "inline-flex",
          alignItems: "center",
          gap: "12px",
        }}>
          <span style={{ fontSize: "24px" }}>⭐</span>
          <span style={{ color: "#FFE66D", fontWeight: 800, fontSize: "20px" }}>{xp} XP</span>
          <span style={{ color: "#a0b4ff", fontSize: "14px" }}>Keep going!</span>
        </div>
      )}

      <h2 style={{ color: "#c0ceff", fontFamily: "'Fredoka One', cursive", fontSize: "26px", marginBottom: "24px" }}>
        Choose Your Grade
      </h2>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        gap: "16px",
        justifyContent: "center",
      }}>
        {Object.entries(CURRICULUM).map(([grade, info]) => (
          <div
            key={grade}
            className="grade-card"
            onClick={() => onSelectGrade(parseInt(grade))}
            style={{
              background: `linear-gradient(135deg, ${info.color}33, ${info.color}15)`,
              border: `2px solid ${info.color}66`,
              borderRadius: "20px",
              padding: "24px 16px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backdropFilter: "blur(10px)",
              animation: `slideUp 0.4s ease ${parseInt(grade) * 0.05}s both`,
            }}
          >
            <div style={{ fontSize: "36px", marginBottom: "8px" }}>{info.emoji}</div>
            <div style={{ fontFamily: "'Fredoka One', cursive", color: info.color, fontSize: "18px" }}>{info.label}</div>
            <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "12px", marginTop: "4px" }}>
              {info.topics.length} topics
            </div>
          </div>
        ))}
      </div>

      <div style={{
        marginTop: "48px",
        display: "flex",
        gap: "24px",
        justifyContent: "center",
        flexWrap: "wrap",
      }}>
        {[
          { emoji: "🧠", label: "Smart Hints" },
          { emoji: "🤖", label: "AI Tutor" },
          { emoji: "🏆", label: "Earn XP" },
          { emoji: "📊", label: "Track Progress" },
        ].map(({ emoji, label }) => (
          <div key={label} style={{
            background: "rgba(255,255,255,0.06)",
            borderRadius: "12px",
            padding: "12px 20px",
            color: "#c0ceff",
            fontSize: "14px",
            fontWeight: 700,
            border: "1px solid rgba(255,255,255,0.08)",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}>
            <span style={{ fontSize: "20px" }}>{emoji}</span> {label}
          </div>
        ))}
      </div>
    </div>
  );
}
